import './Empcar.css';
import attheoffice from '../assets/At the office-rafiki 1.png';
import financeleader from '../assets/Finance leaders-rafiki 1.png';
import successfactor from '../assets/Success factors-rafiki 1.png';
import visionstatement from '../assets/Vision statement-rafiki 1.png';
import browserstat from '../assets/Browser stats-rafiki 1.png';
import gennew from '../assets/Generating new leads-rafiki 1.png';
import orgproj from '../assets/Organizing projects-rafiki (1) 1.png';
import eclipse1 from '../assets/Ellipse 186.png';
import eclipse2 from '../assets/Ellipse 188.png';

function Empcar() {
    return (
        <div className='ec-main-container'>
            <div className='ec-div1'>
                <div className='ec-div2'>
                    <div className='ec-div3'>
                        Welcome to Getmax Solutions and Training Hub
                    </div>
                    <div className='ec-div4'>
                        Empowering Futures, Elevating Careers: GetMax Solutions – Where Placement Meets Training Excellence!
                    </div>
                    <div className='ec-div5'>
                        <a href='' className='ec-cut'>Contact us today!!</a>
                        <a href='' className='ec-es'>Explore Services</a>
                    </div>
                </div>
                <img src={attheoffice} className='ec-ato' />
            </div>
            <div className='ec-div6'>
                <div className='ec-div7'>
                    <div className='ec-div8'> GetMax</div>
                    <p className='ec-p1'>Unleashing Unique Solutions for our Success Story</p>
                    <p className='ec-p2'>
                        At GetMax Training Solutions, we believe that the future is in the hands of the youth of today. And every human has unlimited potential to learn & grow. Our goal is to “awaken the student mentality in all and maximize their potential in real world”.
                    </p>
                </div>
                <img src={successfactor} className='ec-sc' />
            </div>
            <div className='ec-div9'>
                <p className='ec-p3'>
                    <div className='ec-uldiv1' />
                    <b> Our solutions approach </b>
                    <br />
                    for Employment drought
                </p>
                <div className='ec-div10'>
                    <div className='ec-div11'>
                        <p className='ec-p4'>
                            <b>Job Drought Dilemma:</b>
                            <br />
                            Low Placement Rates
                            <br />
                            High Unemployment Rate
                            <br />
                            Mismatched Skill Sets
                            <br />
                            Economic Implications
                        </p>
                        <img src={visionstatement} className='ec-vs' />
                    </div>
                    <div className='ec-div12'>
                        <div className='ec-cont1'>
                            <p className='ec-text'>
                                <b>CSR</b>(Corporate Social Responsibility) <b>program</b>
                            </p>
                        </div>
                        <div className='ec-cont1'>
                            <p className='ec-text'>
                                <b>4-hour workshop </b> where students learn practical job skills
                            </p>
                        </div>
                        <div className='ec-cont1'>
                            <p className='ec-text'>
                                <b>Technical Training Programs</b>
                            </p>
                        </div>
                        <div className='ec-cont1'>
                            <p className='ec-text'>
                                <b>Freshmen Essentials Orientation</b>
                            </p>
                        </div>
                        <div className='ec-cont1'>
                            <p className='ec-text'>
                                <b>Real world Internship projects</b>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className='ec-div13'>
                <p className='ec-p5'>
                    <div className='ec-uldiv2' />
                    Talent Strengthening sessions
                </p>
                <div className='ec-div14'>
                    <div className='ec-div15'>
                        <p className='ec-p6'>
                            Public Speaking Skills
                        </p>
                        <p className='ec-p6'>
                            MS Office (Word, PowerPoint, Excel)
                        </p>
                        <p className='ec-p6'>
                            Interview Facing Etiquettes
                        </p>
                        <p className='ec-p6'>
                            HTML, CSS, JS for Web Designing
                        </p>
                        <p className='ec-p6'>
                            Corel Draw, Photoshop, Illustrator, Figma
                        </p>
                        <p className='ec-p6'>
                            Corporate Etiquettes
                        </p>
                        <p className='ec-p6'>
                            Cybersecurity & Ethical Hacking
                        </p>
                        <p className='ec-p6'>
                            Python, AI, ML Hands-On Training
                        </p>
                        <p className='ec-p6'>
                            Motivational Thinking
                        </p>
                    </div>
                </div>
                <p className='ec-p7'>
                    Enhance efficiency and profitability in professional and technical skills.
                </p>
            </div>
            <div className='ec-div17'>
                <div className='ec-div18'>
                    <p className='ec-p8'>
                        <div className='ec-uldiv2' />
                        Workplace Wizardry Workshops
                    </p>
                    <p className='ec-p9'>
                        beyond training towards triumph
                    </p>
                    <p className='ec-p10'>
                        Resume Building and Optimization
                    </p>
                    <p className='ec-p10'>
                        Job Search Strategies
                    </p>
                    <p className='ec-p10'>
                        Professional Etiquette and Workplace Readiness
                    </p>
                    <p className='ec-p10'>
                        Salary Negotiation and Job Offers
                    </p>
                </div>
                <img src={browserstat} className='ec-bs' />
            </div>
            <div className='ec-div19'>
                <img src={gennew} className='ec-gn' />
                <div className='ec-div16'>
                    <p className='ec-p11'>
                        <div className='ec-uldiv2' />
                        CHOOSE GETMAX FOR CAREER MASTERY
                    </p>
                    <p className='ec-p12'>
                        Results oriented implementation strategies
                    </p>
                    <p className='ec-p12'>
                        Industry-Relevant Curriculum
                    </p>
                    <p className='ec-p12'>
                        Pragmatic Learning experience
                    </p>
                    <p className='ec-p12'>
                        Getting the attention of the students
                    </p>
                </div>
            </div>
            <div className='ec-div20' align='center'>
                <p className='ec-p13'>
                    Here is why GETMAX stands out
                </p>
                <p className='ec-p14'>
                    Post-Training Support
                </p>
                <p className='ec-p14'>
                    Continuous Learning
                </p>
                <p className='ec-p14'>
                    <img src={eclipse1} className='ec-e1' />
                    Customized Training Strategy
                </p>
                <img src={eclipse2} className='ec-e2' />
                <img src={eclipse2} className='ec-e3' />
                <img src={eclipse2} className='ec-e4' />
            </div>
            <div className='ec-div24'>
                <div className='ec-div21'>
                    <div className='ec-div22'>
                        <p className='ec-p15'>
                            <div className='ec-uldiv2' />
                            Benefits offered by the Management
                        </p>
                        <div className='ec-div23'>
                            <p className='ec-p16'>
                                Sustainable Growth
                            </p>
                            <p className='ec-p16'>
                                Streamlined process
                            </p>
                            <p className='ec-p16'>
                                Improved Placement Rates
                            </p>
                            <p className='ec-p16'>
                                Strong Industry Partnerships
                            </p>
                            <p className='ec-p16'>
                                Tailored Cost-Effective Training
                            </p>
                            <p className='ec-p16'>
                                Improved College - Corporate Relations
                            </p>
                        </div>
                    </div>
                    <img src={orgproj} className='ec-op' />
                </div>
                <p className='ec-p17'>
                    Embrace Success with GetMax Solutions: Ensuring Every Student Thrives!
                    Let's Create Memorable Progress with Every Step.
                </p>
            </div>
        </div>
    );
}

export default Empcar;